import React from 'react';
import * as Styled from './styles.js';

class Projects extends React.Component {
  render() {
    const projectList = [
      {
        key: "Valhalla",
        image_url: "Tiles/Valhalla_Thumb.png",
        link: 'https://github.com/sterrio/Avon',
        description: "Avon Thumbnail"
      },
      {
        key: "Avon",
        image_url: "Tiles/Avon_Thumb.png",
        link: 'https://github.com/sterrio/Avon',
        description: "Avon Thumbnail"
      },
      {
        key: "Snacktrack",
        image_url: "Tiles/Snack_Track_Thumbnail.png",
        link: 'https://github.com/mack/snack-track',
        description: "Snacktrack Thumbnail"
      },
      {
        key: "University",
        image_url: "Tiles/Uni_Thumb.png",
        link: 'https://github.com/sterrio/University',
        description: "Temp Thumbnail"
      }
    ]
    return (
      <Styled.Projects>
        {projectList.map(project => (
          <div>
            <a
              key={project.key} href={project.link}>
              <Styled.Tile> <img src={project.image_url} alt={project.description}></img> </Styled.Tile>
            </a>
          </div>
        )
        )}
      </Styled.Projects>
    );
  }
}

export default Projects;
